import { updateKeyInStore } from 'App';
import * as Yup from 'yup';
import { HistoryStateValues, updateKey } from './slice';

export const fields: IBaseField<keyof HistoryStateValues>[] = [
  {
    type: 'date',
    name: 'whenLeftUs',
    label: 'When did you leave the United States to live abroad?',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    placeholder: 'Select Date',
  },
  {
    type: 'radio',
    name: 'didYouMoveToUs',
    label: 'Did you move to the U.S. in the selected year?',
    subLabel: () => <p>If you live abroad, consider a virtual mailbox</p>,
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    dependencies: [
      {
        type: 'text',
        name: 'dateMovedToUs',
        label: 'Provide date when you moved and country names (from -> to)',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
        predicate: (value) => value === 'yes',
        placeholder: 'Enter',
      },
    ],
  },
  {
    type: 'select',
    name: 'filedForm2555',
    label: 'Have you previously filed Form 2555?',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    options: [
      {
        label: 'Previous return filled by Us',
        value: 'Previous return filled by Us',
      },
      { label: 'Yes', value: 'Yes' },
      { label: 'No', value: 'No' },
    ],
    dependencies: [
      {
        type: 'text',
        name: 'filedForm2555Year',
        label: 'What year did you last file this form?',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
        predicate: (value) => value === 'Yes',
        placeholder: 'Enter',
      },
    ],
  },
];

export const validationSchema = Yup.object().shape({});
